<script>
import _ from 'lodash';

import {
  MuiInputLocation,
  MuiButtonFlat,
} from '@ubeeqo/motion-ui';

import defaultLabels from './constants/labels';

export default {
  name: 'PreferredLocationsComponent',

  components: {
    MuiInputLocation,
    MuiButtonFlat,
  },

  props: {
    labels: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    gmapApi: {
      type: Object,
      default: () => ({}),
    },
    change: {
      type: Function,
      default: undefined,
    },
    update: {
      type: Function,
      default: undefined,
    },
    delete: {
      type: Function,
      default: undefined,
    },
  },

  computed: {

    mergedLabels() {
      return _.merge({}, defaultLabels, _.get(this, this.labels));
    },
    addressComponents() {
      return [
        'route',
        'locality',
        'administrative_area_level_1',
        'administrative_area_level_2',
        'postal_code',
        'country_code',
      ];
    },
  },

  methods: {
    addNewLocation(type, uuid) {
      if (uuid) {
        this.delete({ uuid, type });
      }
      this.update(type);
    },
    deleteLocation(uuid, type) {
      this.delete({ uuid, type });
      _.set(this, `$refs.${type}.0.$refs.inputLocation.value`, '');
      _.set(this, `$refs.${type}.0.address`, '');
    },
    changeAddress(address, type) {
      this.change({ address, type });
    },
  },
};
</script>

<template>
  <div
    class="PreferredLocationsComponent"
  >
    <div
      v-for="(location, type) in data"
      :key="type"
      class="my-3"
    >
      <MuiInputLocation
        v-if="gmapApi"
        :ref="type"
        :required-address-components="addressComponents"
        :label="mergedLabels[type]"
        :value="location.address_street"
        :google="gmapApi"
        :placeholder="mergedLabels[type]"
        :name="type"
        full-width
        size="m"
        @change="(value) => changeAddress(value, type)"
      />

      <div
        class="d-flex justify-content-between"
      >
        <MuiButtonFlat
          :uppercase="false"
          size="s"
          @click.native="addNewLocation(type, location.uuid)"
        >
          {{ mergedLabels.addButtonText }}
        </MuiButtonFlat>

        <MuiButtonFlat
          square
          size="s"
          @click.native="deleteLocation(location.uuid, type)"
        >
          <div
            slot="icon"
            class="icons-cross font-xs"
          />
        </MuiButtonFlat>
      </div>
    </div>
  </div>
</template>
